// "há 5 minutos" / "há 2 horas" / "ontem" / "há 3 dias" — formata um
// timestamp ISO relativo a agora, em português.
export const formatarTempoRelativo = (iso: string): string => {
  const diffMs = Date.now() - new Date(iso).getTime();
  const diffMin = Math.floor(diffMs / 60000);

  if (diffMin < 1) return "agora mesmo";
  if (diffMin < 60) return `há ${diffMin} minuto${diffMin === 1 ? "" : "s"}`;

  const diffHoras = Math.floor(diffMin / 60);
  if (diffHoras < 24) return `há ${diffHoras} hora${diffHoras === 1 ? "" : "s"}`;

  const diffDias = Math.floor(diffHoras / 24);
  if (diffDias === 1) return "ontem";
  if (diffDias < 7) return `há ${diffDias} dias`;

  const diffSemanas = Math.floor(diffDias / 7);
  if (diffSemanas < 5) return `há ${diffSemanas} semana${diffSemanas === 1 ? "" : "s"}`;

  const diffMeses = Math.floor(diffDias / 30);
  return `há ${diffMeses} ${diffMeses === 1 ? "mês" : "meses"}`;
};

const MESES_PT = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

const mesmoDia = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

// Formata a data/hora REAL de uma cirurgia de forma não-ambígua: só usa
// "hoje"/"amanhã" quando de fato bate com a data corrente (calculado, nunca
// fixo), caindo pra "29 de agosto[, de 2027]" quando não é hoje nem amanhã —
// evita o tipo de inconsistência de "amanhã" errado que gerou confusão.
export const formatarDataCirurgia = (iso: string): string => {
  const data = new Date(iso);
  const hoje = new Date();
  const amanha = new Date(hoje);
  amanha.setDate(hoje.getDate() + 1);

  const hora = `${String(data.getHours()).padStart(2, "0")}:${String(data.getMinutes()).padStart(2, "0")}`;

  if (mesmoDia(data, hoje)) return `hoje, ${hora}`;
  if (mesmoDia(data, amanha)) return `amanhã, ${hora}`;

  const dataFmt = `${data.getDate()} de ${MESES_PT[data.getMonth()]}`;
  return data.getFullYear() !== hoje.getFullYear()
    ? `${dataFmt} de ${data.getFullYear()}, ${hora}`
    : `${dataFmt}, ${hora}`;
};
